import { render } from "./icon-video.vue?vue&type=template&id=7b5743f3&ts=true"
import script from "./icon-video.vue?vue&type=script&lang=ts"
export * from "./icon-video.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\project\\haocai\\h5\\kousai-group\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__